<template lang="pug">
.section-wrapper
  .section-wrapper__container
    transition(name="fade")
      vm-row.heading-preloader(vm-w="12" v-if="isLoadingPreloader")
        vm-col.preloader(vw=12)
          Preloader
    vm-row.heading(vm-justify="center", vm-align="center", vm-w=12)
      vm-col(vm-type="flex" vm-align="center" vm-sm=12 vm-lg=10)
        vm-button(to="/pages/campaign" icon="arrow-back-outline") Regresar
      vm-col(vm-type="flex" vm-align="center" vm-sm=12 vm-lg=10)
        h2 {{ getTitle }}
    vm-row(vm-justify="center", vm-align="center", vm-w=12)
      vm-col.card.card__wrapper(vm-sm=12 vm-lg=10)
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            label Campaña principal
              vm-switch(v-model="form.isActive")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-select(:placeholder='$t("campaings.template")' :danger="$v.form.template.$invalid && $v.form.template.$model" :danger-text="$t('validation.required', { attribute: $t('campaigns.template') })" v-model="form.template" :label='$t("campaign.template")')
              vm-select-item(:key="index" :value="item.text" :text="item.text" v-for="(item,index) in templates" :selected="item.selected")
          v-default-template(:form="form" v-if="form.template === 'default'")
          vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
              uploader(v-model="fileList" :autoUpload="false" :limit="1" title="Imagen del formulario")
              span.muted {{ $t('strings.help_image_size', {attribute: '500 x 640 pixeles'}) }}
          vm-row.gutters(vm-justify="flex-end", vm-align="center", vm-w=12)
            vm-button(icon="plus" @click="addCampaign" :disabled="!fileValidate || $v.form.template.$invalid") Guardar
        v-testimonials-campaigns(v-if="!isAdd" :campaignId="campaign.id")
</template>

<script>
import Uploader from 'vux-uploader-component'
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import Preloader from '@/components/aditionals/Preloader'
import VDefaultTemplate from '@/components/templates/VDefaultTemplate'
import VTestimonialsCampaigns from '@/components/tables/VTestimonialsCampaigns'
import { createNamespacedHelpers } from 'vuex'
import { required } from 'vuelidate/lib/validators'
const { mapGetters, mapActions } = createNamespacedHelpers('Campaigns')

export default {
  name: 'PageCampaignDetails',
  components: {
    Preloader,
    Uploader,
    VDefaultTemplate,
    VTestimonialsCampaigns
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    form: {
      data: {
        es: {
          description: {
            visible: true
          },
          benefits: {
            visible: true,
            values: []
          },
          aditionalText: {
            visible: true
          }
        },
        en: {
          description: {
            visible: true
          },
          benefits: {
            visible: true,
            values: []
          },
          aditionalText: {
            visible: true
          }
        }
      },
      template: 'default',
      isActive: false
    },
    benefit: null,
    templates: [
      {
        text: 'default',
        selected: true
      }
    ],
    fileList: [],
    isModalAdd: true,
    currentPage: 1,
    formTestimonial: {
      author: '',
      body: '',
      image: ''
    },
    states: [
      {
        id: 1,
        name: 'live'
      }
    ]
  }),
  validations: {
    form: {
      template: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['isLoadingPreloader', 'campaign']),
    fileValidate () {
      return this.fileList.length > 0
    },
    isAdd () {
      return !this.$route.params.slug
    },
    getTitle () {
      return !this.$route.params.slug ? 'Agregar una nueva campaña' : `Editar campaña: ${this.form.data.es.title}`
    }
  },
  watch: {
    '$route.params' () {
      this.loadPageData()
    },
    campaign (campaign) {
      if (campaign.id) {
        if (campaign.image) this.fileList = [{ name: campaign.id, url: campaign.image }]
        this.$router.push({ params: { slug: campaign.slug_es } })
      }
    }
  },
  async created () {
    await this.loadPageData()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'loadRecord',
      'editRecord'
    ]),
    addTestimonial () {
      this.formTestimonial = {}
      this.setModalTestimonialCampaignsVisible(true)
    },
    deleteTestimonialConfirm (testimonial) {
      let t = this
      this.auxDeleteTestimonial = () => {
        t.deleteTestimonialCampaign(testimonial).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', { model: this.$t('strings.testimonial'), attribute: testimonial.author }),
        accept: this.auxDeleteTestimonial
      })
    },
    async addCampaign () {
      await !this.$route.params.slug ? this.addRecord({
        ...this.form,
        asset: this.fileList[0].blob,
        title_es: this.form.data.es.title,
        title_en: this.form.data.en.title
      }) : this.editRecord({
        ...this.form,
        asset: this.fileList[0].blob ? this.fileList[0].blob : false,
        title_es: this.form.data.es.title,
        title_en: this.form.data.en.title
      })
    },
    async loadPageData () {
      if (this.$route.params.slug) {
        await this.loadRecord({ id: this.$route.params.slug })
        this.formatData()
      }
    },
    formatData () {
      this.form = {
        ...this.campaign,
        data: JSON.parse(this.campaign.data),
        isActive: Number(this.campaign.is_active) === 1
      }
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}

.gutters {
  padding: 0 10px !important;
}
.card {
  padding: 20px;
}
</style>
